import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuthUser } from "../../contexts/AuthUserContext";
import { API_BASE } from "../../utils/api/api";

const PENDING_WELCOME_INTENT_KEY = "zeqi:pendingWelcomeIntent";
const ACTIVE_CHANNEL_STORAGE_KEY = "zeqi:activeChannelId";
const ACTIVE_SUBCHANNEL_STORAGE_KEY = "zeqi:activeSubchannelId";

const EmailVerifyPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { signIn } = useAuthUser();

  const email = location.state?.email || "";
  const password = location.state?.password || "";
  const name = location.state?.name || "";

  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleVerify = async () => {
    setError("");
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE}/api/otp/verify-auth`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp, password, name }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Verification failed");

      try {
        window.sessionStorage.setItem(
          PENDING_WELCOME_INTENT_KEY,
          "email_post_auth",
        );
        window.sessionStorage.setItem(ACTIVE_CHANNEL_STORAGE_KEY, "main");
        window.sessionStorage.removeItem(ACTIVE_SUBCHANNEL_STORAGE_KEY);
      } catch {
        // ignore sessionStorage issues
      }

      signIn({
        userId: data.userId,
        token: data.token,
        onboarding: data.user?.onboarding || null,
      });

      navigate(data.nextRoute || "/", { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    try {
      await fetch(`${API_BASE}/api/otp/send`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, name }),
      });
    } catch {
      // silent
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem 1.25rem",
        background: "var(--bg-app)",
      }}
    >
      <div
        style={{
          width: "min(420px, 100%)",
          background: "var(--bg-sb)",
          border: "1px solid var(--bd)",
          borderRadius: 24,
          padding: "2.5rem 2rem",
          boxShadow: "var(--app-shadow)",
          textAlign: "center",
        }}
      >
        <h2 style={{ margin: "0 0 0.25rem", fontSize: 22, fontWeight: 700, color: "var(--tp)" }}>
          Verify your email
        </h2>
        <p style={{ margin: "0 0 1.75rem", fontSize: 14, color: "var(--ts2)" }}>
          Enter the 6-digit code sent to <strong>{email}</strong>
        </p>
        <input
          type="text"
          inputMode="numeric"
          maxLength={6}
          value={otp}
          onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
          placeholder="000000"
          style={{
            width: "100%",
            padding: "0.875rem",
            borderRadius: 12,
            border: "1px solid var(--input-border)",
            background: "var(--input-bg)",
            color: "var(--tp)",
            fontSize: 22,
            fontWeight: 700,
            textAlign: "center",
            letterSpacing: "0.25em",
            boxSizing: "border-box",
            marginBottom: "1rem",
          }}
        />
        {error && (
          <p style={{ fontSize: 13, color: "var(--danger-text)", marginBottom: "0.75rem" }}>{error}</p>
        )}
        <button
          onClick={handleVerify}
          disabled={loading || otp.length !== 6}
          style={{
            width: "100%",
            padding: "0.875rem",
            borderRadius: 999,
            border: "none",
            background: "var(--ac)",
            color: "var(--hero-contrast)",
            fontSize: 15,
            fontWeight: 700,
            cursor: otp.length === 6 ? "pointer" : "not-allowed",
            opacity: otp.length !== 6 ? 0.55 : 1,
          }}
        >
          {loading ? "Verifying…" : "Verify and continue"}
        </button>
        <p style={{ marginTop: "1.25rem", fontSize: 13, color: "var(--ts2)" }}>
          Didn't receive a code?{" "}
          <button
            type="button"
            onClick={handleResend}
            style={{ background: "none", border: "none", color: "var(--ac)", cursor: "pointer", fontWeight: 600, padding: 0 }}
          >
            Resend
          </button>
        </p>
      </div>
    </div>
  );
};

export default EmailVerifyPage;
